<ng-template #modal>
  <div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="btn-close" (click)="hide()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <ng-content></ng-content>
  </div>
  <div class="modal-footer">
    @if (secondaryActionText) {
    <button [disabled]="!secondaryActionEnabled" class="btn btn-warning me-auto"
      (click)="secondaryAction.emit()" [ladda]="loading">{{secondaryActionText | translate}}</button>
    }
    <button type="button" class="btn btn-outline-secondary" (click)="hide()">
      @if (editable) {
      <div>{{ 'cancel' | translate }}</div>
      } @else {
      <div>{{ 'close' | translate }}</div>
      }
    </button>
    @if (editable) {
    <button [disabled]="!isSaveValid" type="button" class="btn btn-secondary" (click)="save()" [ladda]="loading"
      >{{'save' | translate}}</button>
    }
  </div>
</ng-template>
